import {useState} from 'react'
import { Card4 } from '../../../../../_metronic/partials/content/cards/Card4'
import { useAppSelector } from '../../../../../redux/hooks'
import axios from 'axios'
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/plain.css'

const API_URL = process.env.REACT_APP_API_URL


export default function HelpRequest() {
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  // eslint-disable-next-line
    const [loading, setLoading] = useState(false)
  // eslint-disable-next-line
    const [Resumen, setResumen] = useState('');
    const [Descripcion, setDescripcion] = useState('');
    const [files, setfiles] = useState<File[]>();
    const [Contacto,setContacto] = useState('');
    const [Correo,setCorreo] = useState('');
    const [phone_number,setPhone_number] = useState('');



    const navigate = useNavigate();
   
    /********************************************************* */
    const handleChange = (event:any) => {
      // eslint-disable-next-line
      const file = event.target.files[0]
      setfiles(
          event.target.files
      )}

     const handleSubmit =async (e:any) => {
      e.preventDefault();

      try{
        var formData = new FormData();
        formData.append("Tipo", 'Help Request' )
        formData.append("Resumen", Resumen);
        formData.append("Prioridad", '1');
        formData.append("Descripcion", Descripcion)
        if(files){
          for(const x of files){
        formData.append("files[]", x);}}
        formData.append("Nombre_de_contacto", Contacto)
        formData.append("Correo", Correo)
        formData.append("phone_number", phone_number)

        


       

        
        await axios.post(API_URL+'/v1/support/CreatedTicket', formData,{
          headers: {
            'Content-Type': 'multipart/form-data'
          }
      })
        navigate('/support/SeeRequest')
      }
      catch(error:any){
        console.log(error)

      }

      
     }
     


     ////////////////////
     const [isChecked, setIsChecked] = useState(false);

    
      const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsChecked(event.target.checked);
      };
  

    return(

        <>
              {/* begin::Row */}
              <div className='row g-5 g-xl-8'>
                <div className='col-xl-3'></div>
        
                <div className='col-xl-6'>
                    <div className="card card-custom ">
                        <div className="card-header align-items-center bg-info-td ribbon ribbon-end ribbon-clip">
                            <Link to='/support/OpenRequest' className="ribbon-label text-marino f-parrafo">
                              Back
                              <span className="ribbon-inner bg-light-cian"></span>
                            </Link>
                            <h3 className="card-title text-secondary fw-bolder">CUSTOMER SUPPORT</h3>
                        </div>
                        <div className="card-body">
                        <form className='form w-100' id='kt_login_signin_form' onSubmit={handleSubmit} >
                                {/* begin::Heading */}
                                <Card4
                                icon='/media/imgv2/logo_rosa_dos.png'
                                title=' '
                                description=''></Card4>
                                <div className='text-center mb-5'>
                                <h1 className='text-marino fw-bolder mb-3 f-parrafo fs-md'>Help Request</h1>
                                </div>
                                {/* begin::Heading */}
                        
                                {/* begin::Login options */}

                                <div className='mb-2 bg-light-info p-8 rounded f-parrafo'>
                                    <div className='text-info'>
                                     If you have any questions you can contact us through this medium
                                    </div>
                                </div>
                                {/* Campos solicitud */}
                                <div className='fv-row mb-3 f-parrafo'>
                                  <label className='form-label fw-bolder text-dark fs-6 mb-0 required form-label'>Title</label>
                                    <input
                                      required
                                      type="text"
                                      className="form-control form-control-solid border-gray-300 "
                                      placeholder="Write a brief description"
                                      id='Resumen'
                                      value={Resumen}
                                      onChange={(e:any) => setResumen(e.target.value)} 
                                      maxLength={150}
                                      
                                    />
                                </div>
                                                           
                                 {/* Campos solicitud */} 
                                 <div className='fv-row mb-3 f-parrafo'>
                                  <label className='form-label fw-bolder text-dark fs-6 mb-0 required form-label'>Description</label>
                                    <textarea
                                      required
                                      className="form-control form-control-solid border-gray-300"
                                      placeholder="Description of the problem (required)"
                                      rows={10}
                                      id='Descripcion'
                                      value={Descripcion}
                                      onChange={(e:any) => setDescripcion(e.target.value)} 
                                    />
                                </div>
                                {/* Campos solicitud */}
                                <div className='fv-row mb-3 f-parrafo'>
                                  <label className='form-label fw-bolder text-dark fs-6 mb-0'>Attach (Drag and drop screenshots or browse your device)</label>
                                    <input
                                      type="file"
                                      className="form-control form-control-solid border-gray-300 "
                                      name='Adjuntar'
                                      multiple
                                      onChange={(e) => handleChange(e)}
                                      
                                    />
                                </div>
                                 {/* Campos solicitud */}
                                <div className="fv-row mb-3 f-parrafo">
                                  <div className="form-check form-switch form-check-custom form-check-solid">
                                      <input className="form-check-input border border-info" 
                                      type="checkbox" 
                                      checked={isChecked}
                                      onChange={handleCheckboxChange}
                                      value="activar" 
                                      id="activador"
                                      />
                                      <label className="form-check-label text-info fw-bolder" >
                                        I WANT TO SEND A RESPONSE OF THE CASE TO ANOTHER PERSON
                                      </label>
                                  </div>
                                </div>
                                {/* Campos solicitud */}
                                <div className='fv-row mb-3 f-parrafo'>
                                  <label hidden={!isChecked} className='form-label fw-bolder text-dark fs-6 mb-0'>Contact Name</label>
                                    <input
                                      type="text"
                                      className="form-control form-control-solid border-gray-300 "
                                      placeholder="Escribe los correos de soporte"
                                      id='Contacto'
                                      hidden= {!isChecked}
                                      value={Contacto}
                                      onChange={(e) => setContacto(e.target.value)}
                                    />
                                </div>
                                 {/* Campos solicitud */}
                                 <div className='fv-row mb-3 f-parrafo'>
                                  <label hidden={!isChecked} className='form-label fw-bolder text-dark fs-6 mb-0'>Contact Email</label>
                                    <input
                                      type="email"
                                      className="form-control form-control-solid border-gray-300 "
                                      placeholder="Escribe los correos de soporte"
                                      hidden= {!isChecked}

                                      id='Correo'
                                      value={Correo}
                                      onChange={(e) => setCorreo(e.target.value)}
                                     
                                     
                                      
                                    />
                                  </div>
                                  <div className='fv-row mb-3 f-parrafo' hidden= {!isChecked}>
                                    <label className='form-label fw-bolder text-dark fs-6 mb-0'>Contact Phone</label>
                                    <PhoneInput
                                        country={'mx'}
                                        value={phone_number}
                                        onChange={phone => setPhone_number(phone)}
                                        inputClass={"bg-light-info text-info border-gray-300"}
                                      />
                                  </div>

                               
                                {/* begin::Action */}
                                <div className='d-grid mb-10 justify-content-center'>
                                  
                                  <button
                                    type='submit'
                                    id='kt_sign_in_submit'
                                    className='btn btn-primary'
                             
                                    
                                  >
                                    {!loading && <span className='indicator-label'>Save</span>}
                                    {loading && (
                                      <span className='indicator-progress' style={{display: 'block'}}>
                                       Please wait...
                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                      </span>
                                    )}
                                  </button>
                                </div>
                                {/* end::Action */}

                            </form>
                        </div>
                        
                    </div>
                    

                </div>
        
                <div className='col-xl-3'></div>
              </div>
              {/* end::Row */} 
            </>

        
      
    )
    }